import arrowleft from "@Images/NewUI/Vector.png";
import React from "react";



const MainHeading = (props) => {
  const {questionVisible=false, setModalState} =  props
  
  return (
    <div className="sticky-header" style={{ display:"flex", justifyContent:'flex-start', alignItems:'center', padding:'30px 0px 30px'}}>

      {!(props.hideArrow) ?
       ( <img style={{cursor:"pointer", marginLeft:"28px", marginRight:"28px"}} width={10}  src={arrowleft} onClick={() => {

        if(localStorage.getItem('from_deeplink')){
          window.location.href="/dashboard_s";
        }
        else if(props?.path==="/dashboard_s"){
            window.location.href="/dashboard_s";
          }
          else{
            window.location.href="/dashboard_s";
          }
        }} />):null}
        <h1 className="boldheading" style={{ paddingLeft:"0px", color:'#152745', fontWeight:'700', fontSize:'25px'}}>{props?.headingText}</h1>
        {/* {questionVisible && <img className="imageQuestionMark questionCustom"
            onClick={() => {
              setModalState(true);
            }}
            src={questionImage}
          />} */}
    </div>
  );
};

export default MainHeading;
